import { render, staticRenderFns } from "./TaskTab.vue?vue&type=template&id=264a86b5&scoped=true&"
import script from "./TaskTab.vue?vue&type=script&lang=ts&"
export * from "./TaskTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264a86b5",
  null
  
)

export default component.exports